module.exports = __webpack_public_path__ + "static/media/team-member-2.1eb783e3.png";